import React, { Fragment, useEffect, useState } from 'react'
import { Button, Card, CardBody, Col, Container, Form, FormGroup, Input, Label, Row } from 'reactstrap'
import Breadcrumbs from '../../../CommonElements/Breadcrumbs'
import EditProfile from './EditProfile/EditProfile/index'
import { Address, EditProfileTitle, Email, EmailAddress, FirstName, LastName, Password, UserProfileTitle, UsersTitle } from '../../../Utils/Constants'
import MyProfile from './EditProfile/MyProfile'
import { useLocation } from 'react-router-dom'
import { dynamicImage } from '../../../Utils'
import { Image, P, H3, Alerts, Btn } from '../../../AbstractElements'
import { register } from 'module'
import { useForm } from 'react-hook-form'
import { API } from '../../../api/API'
import { getData, postData } from '../../../CommonElements/Functions/PostGetFun'
import { toast } from 'react-toastify'
import { set } from 'lodash'
import BorderTabs from '../../UiKits/Tabs/BorderTabs'
import CardHeaderSpan from '../../../Utils/CommonComponents/CardHeaderSpan'
import { em } from '@fullcalendar/core/internal-common'
import CommonModal from '../../../CommonElements/Functions/CommonModels'
import { ensureDexieReady, getActivePermKeysFromDexie, getDataFromDexie } from '../../../db/DexieServises'
import FeatherIconCom from '../../../Utils/CommonComponents/CommonIcons/FeatherIconCom'
interface UserProfilesProps {
    employeeIdProp?: number;
}
export default function UserProfiles({ employeeIdProp }: UserProfilesProps) {
    const [isDisabled, setIsDisabled] = useState(true);
    const location = useLocation();
    // const employeeId = location.state?.employeeId;
    const employeeId1 = location.state?.employeeId ?? employeeIdProp;
    const employeeId = employeeId1 == 1 ? null : employeeId1;
    const { register, formState: { errors } } = useForm();
    const [firstNames, setFirstNames] = useState(null);
    const [positionName, setpositionName] = useState('');
    const [reportingToPositionName, setReportingToPositionName] = useState('');
    const [lastLogin, setLastLogin] = useState(0);
    const [statuss, setstatuss] = useState(0);
    const [islocked, setIslocked] = useState(false);
    const [lockedreason, setLockedreason] = useState('');
    const [iseodcheckenabled, setIseodcheckenabled] = useState('');
    const [phone, setPhone] = useState('');
    const [phoneUser, setPhoneUser] = useState('');
    const [emailUser, setemailUser] = useState('');
    const [firstName, setFirstName] = useState('');
    const [username, setUsername] = useState('');
    const [lastName, setLastName] = useState('');
    const [address, setAddress] = useState('');
    const [remark, setRemark] = useState('');
    const [employeeCode, setEmployeeCode] = useState('');
    const [email, setemail] = useState('');
    const [birthDate, setBirthDate] = useState('');
    const [joinDate, setJoinDate] = useState('');
    const [probationDate, setProbationDate] = useState('');
    const [lockeddate, setLockeddate] = useState('');
    const [designation, setDesignation] = useState('');
    const [gradeName, setGradeName] = useState('');
    const [geoTownName, setGeoTownName] = useState('');
    const [branchName, setBranchName] = useState('');
    const [confirmationDate, setConfirmationDate] = useState('');
    const [trainingStartDate, setTrainingStartDate] = useState('');
    const [trainingEndDate, setTrainingEndDate] = useState('');
    const [resignDate, setResignDate] = useState('');
    const [transferDate, setTransferDate] = useState('');
    const [relivingDate, setRelivingDate] = useState('');
    const [nsmApproveDate, setNsmApproveDate] = useState('');
    const [resignationRejectedDate, setResignationRejectedDate] = useState('');
    const [personalBank, setPersonalBank] = useState('');
    const [personalAccountNumber, setPersonalAccountNumber] = useState('');
    const [pfEsicContribution, setPfEsicContribution] = useState('');
    const [pfNumber, setPfNumber] = useState('');
    const [esciNumber, setEsciNumber] = useState('');
    const [grossSalary, setGrossSalary] = useState('');
    const [paymentMode, setPaymentMode] = useState('');
    const [salaryBank, setSalaryBank] = useState('');
    const [salaryAccountNumber, setSalaryAccountNumber] = useState('');
    const [tdsStatus, setTdsStatus] = useState('');
    const [resiAddress, setResiAddress] = useState('');
    const [isdCode, setIsdCode] = useState('');
    const [costnumber, setCostnumber] = useState('');
    const [ipAddress, setIpAddress] = useState('');
    const [employeeSpokenLanguage, setEmployeeSpokenLanguage] = useState('');
    const [loading, setLoading] = useState(true);

    // const lLogin = new Date(lastLogin * 1000).toLocaleString('en-IN')

    const date = new Date(lastLogin * 1000);

    const timePart = date.toLocaleTimeString('en-IN', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
    });

    const datePart = date.toLocaleDateString('en-IN', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    }).replace(/\//g, '-');

    const lLogin = `${timePart}, ${datePart}`;

    const statusLabel = statuss === 1 ? 'Active' : 'Inactive';
    const lockedLabel = islocked == true ? 'Locked' : 'Not Locked';

    const serverUrl = localStorage.getItem('serverUrl');
    const myEmpId = localStorage.getItem('empId');
    console.log(employeeId, myEmpId, 'employeeid=======================');

    const APP_TOKEN = localStorage.getItem('appToken') || false;
    const [emailUsers, setemailUsers] = useState('');
    const [usernames, setUsernames] = useState(null);
    const [userphons, setUserphons] = useState('');

    const handleSubmit = async () => {

        // console.log(employeeIdProp, 'data =======usertable=========');
        await ensureDexieReady();

        const userdata = await getDataFromDexie('User');

        setemailUsers(userdata[0]?.Email);
        setUsernames(userdata[0]?.Username);
        setUserphons(userdata[0]?.Phone);


        // console.log(userdata, employeeIdProp, 'data =======usertable after==userdata=======');

        const url = `${serverUrl}${API.getEmployeeInfo}`;
        if (!serverUrl || !APP_TOKEN) {
            console.error('❌ Missing server URL or app token');
            return;
        }
        const { status, data } = await getData(url, true, {
            employee_id: employeeId
        });
        // console.log(data, 'response data getEmployeeInfo');

        const phonenum = '+' + data?.data?.user?.IsdCode + ' ' + data?.data?.user?.Phone || 'Mo. number';

        if (status === 200) {
            setFirstNames(data?.data?.user?.Name);
            setpositionName(data?.data?.employee?.PositionName);
            setemailUser(data?.data?.user?.Email);
            setemail(data?.data?.employee?.Email);
            setstatuss(data?.data?.user?.Status);
            setUsername(data?.data?.user?.Username);
            setPhoneUser(data?.data?.user?.Phone);
            setLastLogin(data?.data?.user?.LastLogin);
            setIsdCode(data?.data?.user?.IsdCode);
            setPhone(data?.data?.employee?.Phone);
            setIpAddress(data?.data?.user?.IpAddress);
            setFirstName(data?.data?.employee?.FirstName)
            setLastName(data?.data?.employee?.LastName)
            setAddress(data?.data?.employee?.Address)
            setRemark(data?.data?.employee?.Remark)
            setResiAddress(data?.data?.employee?.ResiAddress)
            setCostnumber(data?.data?.employee?.Costnumber)
            setEmployeeCode(data?.data?.employee?.EmployeeCode)
            setIslocked(data?.data?.employee?.Islocked)
            setLockeddate(data?.data?.employee?.Lockeddate)
            setDesignation(data?.data?.employee?.Designation)
            setGradeName(data?.data?.employee?.GradeName)
            setGeoTownName(data?.data?.employee?.GeoTownName)
            setIseodcheckenabled(data?.data?.employee?.Iseodcheckenabled == 0 ? 'No' : 'Yes')
            setBranchName(data?.data?.employee?.BranchName)
            setLockedreason(data?.data?.employee?.Lockedreason)
            setReportingToPositionName(data?.data?.employee?.ReportingToPositionName)
            setEmployeeSpokenLanguage(data?.data?.hr_dates?.EmployeeSpokenLanguage)
            setBirthDate(data?.data?.hr_dates?.BirthDate)
            setJoinDate(data?.data?.hr_dates?.JoinDate)
            setProbationDate(data?.data?.hr_dates?.ProbationDate)
            setConfirmationDate(data?.data?.hr_dates?.ConfirmationDate)
            setTrainingStartDate(data?.data?.hr_dates?.TrainingStartDate)
            setTrainingEndDate(data?.data?.hr_dates?.TrainingEndDate)
            setResignDate(data?.data?.hr_dates?.ResignDate)
            setTransferDate(data?.data?.hr_dates?.TransferDate)
            setRelivingDate(data?.data?.hr_dates?.RelivingDate)
            setNsmApproveDate(data?.data?.hr_dates?.NsmApproveDate)
            setResignationRejectedDate(data?.data?.hr_dates?.ResignationRejectedDate)
            setPersonalBank(data?.data?.hr_account?.PersonalBank)
            setPersonalAccountNumber(data?.data?.hr_account?.PersonalAccountNumber)
            setPfEsicContribution(data?.data?.hr_account?.PfEsicContribution)
            setPfNumber(data?.data?.hr_account?.PfNumber)
            setEsciNumber(data?.data?.hr_account?.EsciNumber)
            setGrossSalary(data?.data?.hr_account?.GrossSalary)
            setPaymentMode(data?.data?.hr_account?.PaymentMode)
            setSalaryBank(data?.data?.hr_account?.SalaryBank)
            setSalaryAccountNumber(data?.data?.hr_account?.SalaryAccountNumber)
            setTdsStatus(data?.data?.hr_account?.TdsStatus)
            setLoading(false); // 👈 Stop loader

            // toast.success(data.message);
        } else {
            // toast.error(data.message)
        }
        setLoading(false); // 👈 Stop loader

    };
    useEffect(() => {
        handleSubmit();
    }, [employeeId]);
    const [modalOpen, setModalOpen] = useState(false);
    const [modalOpen4, setModalOpen4] = useState(false);
    const [loadings, setLoadings] = useState(false);
    const [secretKey, setSecretKey] = useState('');
    // console.log(employeeId,myEmpId,'employeeid,MyEmpid=======================');

    const handleUnlock = async () => {


        setLoadings(true);
        setLoading(true); // 👈 loader

        try {
            const url = `${serverUrl}${API.unlockAccount}`;
            const isActive = statuss === 1;

            const { status, data } = await postData(url, true, { employee_id: employeeId });
            // console.log(data, 'response data');

            if (status === 200) {
                toast.success(data.message || 'Account unlocked successfully');
                setLoading(false); // 👈 Stop loader

            } else {
                toast.error(data.message || 'Failed to unlock account');
            }
        } catch (err) {
            console.error(err);
            toast.error('Failed to unlock.');
        } finally {
            setLoadings(false);
            setLoading(false); // 👈 Stop loader

            setModalOpen(false);
        }
    };
    const handleUpdateEmployeeDetails = async () => {
        if (!employeeId) {
            toast.error('Employee ID is required');
            return;
        }

        const basePayload = {
            employee_id: employeeId,
            first_name: firstName,
            last_name: lastName,
            email,
            phone,
            // ip_address: ipAddress, // you can set if you capture it
            resi_address: resiAddress,
            address,
            costnumber,
            remark,
            employee_spoken_language: employeeSpokenLanguage,
            birth_date: birthDate,
            join_date: joinDate,
            probation_date: probationDate,
            confirmation_date: confirmationDate,
            training_start_date: trainingStartDate,
            training_end_date: trainingEndDate,
            transfer_date: transferDate,
            reliving_date: relivingDate,
            nsm_approve_date: nsmApproveDate,
            resignation_rejected_date: resignationRejectedDate,
            personal_bank: personalBank,
            personal_account_number: personalAccountNumber,
            pf_esic_contribution: pfEsicContribution,
            pf_number: pfNumber,
            esci_number: esciNumber,
            gross_salary: grossSalary,
            payment_mode: paymentMode,
            salary_bank: salaryBank,
            salary_account_number: salaryAccountNumber,
            tds_status: tdsStatus,
            username,
            // isd_code: isdCode,
        };

        // Remove empty / null / undefined fields
        const payload: Record<string, string> = {};
        Object.entries(basePayload).forEach(([key, value]) => {
            if (value !== undefined && value !== null && String(value).trim() !== '') {
                payload[key] = String(value).trim();
            }
        });

        try {
            setLoading(true);

            const url = `${serverUrl}${API.UpdateEmployeeDetails}`;

            // console.log('🚀 Sending payload:', payload);

            const { status, data } = await postData(url, true, payload);

            if (status === 200) {
                toast.success(data.message || 'Employee details updated successfully');
                setModalOpen4(false);
                // optionally refresh employee list/details
            } else {
                toast.error(data.message || 'Failed to update employee details');
            }
        } catch (err) {
            console.error(err);
            toast.error('Something went wrong while updating.');
        } finally {
            setLoading(false);
        }
    };


    const [permissions, setPermissions] = useState<string[]>([]);
    // console.log(usernames, 'permissionsmployeeIdProp && employeeIdProp !== 1 && ');
    useEffect(() => {
        getActivePermKeysFromDexie().then(setPermissions);
    }, []);
    return (
        <div className=''>
            {loading ? (
                <div className="text-center py-3">
                    {/* <span className="spinner-border text-primary" role="status" aria-hidden="true" /> */}
                    <div>
                        <Image
                            className="b-r-10 img-80"
                            src={dynamicImage('dashboard/loader.gif')}
                            alt="Loading..."
                        />
                    </div>
                </div>
            ) : (
                <div className='pt-3'>

                    <Container fluid>
                        <div className="edit-profile">

                            <Row><Col xl={12}>

                                {permissions.includes('can_do_empunlock') && myEmpId != employeeId && islocked &&
                                    <div className='pb-2' onClick={() => setModalOpen(true)} style={{ cursor: 'pointer' }}>
                                        <Alerts color='default' className={`${islocked ? 'border-danger' : 'border-success'} alert-dismissible bg-danger fade p-0 mb-0 `}>
                                            <div className={`alert-arrow ${islocked ? 'bg-danger' : 'bg-success'}`}>
                                                <i className={`${islocked ? 'icon-lock' : 'icon-unlock'} `} style={{ fontSize: '20px' }} />
                                            </div>
                                            <h2 className='text-white'>{islocked ? lockedreason || 'Account is Locked' : 'Account is Active'}</h2>
                                            <Btn className="p-0 border-0 me-2 ms-auto" type="button"
                                            >
                                                <h4 className={`${islocked ? 'bg-danger' : 'bg-success'}  text-white px-3 py-1`} aria-hidden="true">{'Unlock'}</h4>
                                            </Btn>
                                        </Alerts></div>
                                }

                            </Col>
                                <Col xl={4}>
                                    <Card>
                                        {/* <CommonCardHeader headClass='pb-0' titleClass='card-title' title={MyProfileTitle} /> */}
                                        <CardBody>
                                            <Form onSubmit={(e) => e.preventDefault()}>
                                                <Row className="mb-2">
                                                    <div className="profile-title">
                                                        <div className="d-flex">
                                                            <Image className="img-70 rounded-circle" alt="" src={dynamicImage(`user/user.png`)} body={true} />
                                                            <div className="flex-grow-1">
                                                                <H3 className="mb-1">{firstNames || usernames || 'Admin'}</H3>
                                                                {employeeId != null && <div className='d-flex m-0 gap-2'>
                                                                    {myEmpId == employeeId && <p style={{ fontWeight: 500, }} className={statuss === 1 ? 'text-success m-0' : 'text-danger m-0'}>{statusLabel || '-'}</p>}
                                                                    {!islocked && myEmpId != employeeId && <p style={{ fontWeight: 500, }} className={statuss === 1 ? 'text-success m-0' : 'text-danger m-0'}>{statusLabel || '-'}</p>}

                                                                </div>}


                                                                <CommonModal
                                                                    isOpen={modalOpen}
                                                                    toggle={() => setModalOpen(false)}
                                                                    title="Are you sure you want to unlock this account?"
                                                                    size="md"
                                                                >
                                                                    <div className="p-2 text-center">
                                                                        <FeatherIconCom iconName={'Unlock'} size={70} className='text-success' />

                                                                        <div className="d-flex justify-content-end gap-2 mt-4">
                                                                            <button
                                                                                className="btn btn-success"
                                                                                onClick={handleUnlock}
                                                                                disabled={loadings}
                                                                            >
                                                                                {loadings ? 'Unlocking...' : 'Yes, Submit'}
                                                                            </button>
                                                                            <button
                                                                                className="btn btn-secondary"
                                                                                onClick={() => setModalOpen(false)}
                                                                            >
                                                                                Cancel
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </CommonModal>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </Row>
                                                {/* <ChangePasswordModal/> */}
                                                {employeeId != null && <FormGroup>
                                                    <Label>{'Last Login'}</Label>
                                                    <Input type="text" disabled placeholder={lLogin || '-'} />
                                                </FormGroup>}
                                                <FormGroup>
                                                    <Label>{'User Name'}</Label>
                                                    <Input type="text" disabled={isDisabled} placeholder={username || usernames || '-'} />
                                                </FormGroup>
                                                <FormGroup>
                                                    <Label>{'Phone '}</Label>
                                                    <Input type="number" disabled={isDisabled} placeholder={phoneUser || userphons || '-'} />
                                                </FormGroup>
                                                <FormGroup>
                                                    <Label>{EmailAddress}</Label>
                                                    <Input type="email" disabled={isDisabled} placeholder={emailUser || emailUsers || '-'} />
                                                </FormGroup>
                                                <div className="form-footer">
                                                </div>
                                            </Form>
                                        </CardBody>
                                    </Card>
                                </Col>
                                {employeeId != null && <Col xl={8}>
                                    <Card>
                                        <Form>
                                            <CardBody>
                                                <Row>
                                                    <div className='d-flex justify-content-between  align-items-center'> <p style={{ fontSize: 18, }}>{'Employee Information:'}</p>
                                                        {/* <Button className='mb-3' color='primary' onClick={() => setModalOpen4(true)}>
                                                            Update Employee Details
                                                            <FeatherIconCom
                                                                iconName={ 'Edit'}
                                                                size={20}
                                                            />
                                                        </Button> */}
                                                    </div>
                                                    {/* <Col sm={6} md={6}>
                                                        <FormGroup>
                                                            <Label>{FirstName}</Label>
                                                            <input disabled={isDisabled} className="form-control" type="text" placeholder={firstName || '-'} />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col sm={6} md={6}>
                                                        <FormGroup>
                                                            <Label>{LastName}</Label>
                                                            <input disabled={isDisabled} className="form-control" type="text" placeholder={lastName || '-'} />
                                                        </FormGroup>
                                                    </Col> */}
                                                    <Col sm={6} md={6}>
                                                        <FormGroup>
                                                            <Label>{'Position Name'}</Label>
                                                            <input disabled={isDisabled} className="form-control" type="text" placeholder={positionName || '-'} />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col sm={6} md={6}>
                                                        <FormGroup>
                                                            <Label>{'Reporting To Position Name'}</Label>
                                                            <input disabled={isDisabled} className="form-control" type="text" placeholder={reportingToPositionName || '-'} />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col sm={4} md={4}>
                                                        <FormGroup>
                                                            <Label>{'Employee Email'}</Label>
                                                            <input disabled={isDisabled} className="form-control" type="text" placeholder={email || '-'} />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col sm={4} md={4}>
                                                        <FormGroup>
                                                            <Label>{'Employee Phone'}</Label>
                                                            <input disabled={isDisabled} className="form-control" type="text" placeholder={phone || '-'} />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col sm={4} md={4}>
                                                        <FormGroup>
                                                            <Label>{'Employee Code'}</Label>
                                                            <input disabled={isDisabled} className="form-control" type="text" placeholder={employeeCode || '-'} />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col sm={4} md={4}>
                                                        <FormGroup>
                                                            <Label>{'Is EOD Check Enabled'}</Label>
                                                            <input disabled={isDisabled} className="form-control" type="text" placeholder={iseodcheckenabled || '-'} />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col sm={4} md={4}>
                                                        <FormGroup>
                                                            <Label>{'Islocked'}</Label>
                                                            <input disabled={isDisabled} className="form-control" type="text" placeholder={lockedLabel || '-'} />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col sm={4} md={4}>
                                                        <FormGroup>
                                                            <Label>{'Locked Date'}</Label>
                                                            <input disabled={isDisabled} className="form-control" type="text" placeholder={lockeddate || '-'} />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col sm={4} md={4}>
                                                        <FormGroup>
                                                            <Label>{'Locked Reason'}</Label>
                                                            <input disabled={isDisabled} className="form-control" type="text" placeholder={lockedreason || '-'} />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col sm={4} md={4}>
                                                        <FormGroup>
                                                            <Label>{'Designation'}</Label>
                                                            <input disabled={isDisabled} className="form-control" type="text" placeholder={designation || '-'} />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col sm={4} md={4}>
                                                        <FormGroup>
                                                            <Label>{'Grade Name'}</Label>
                                                            <input disabled={isDisabled} className="form-control" type="text" placeholder={gradeName || '-'} />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col sm={4} md={4}>
                                                        <FormGroup>
                                                            <Label>{'Geotown Name'}</Label>
                                                            <input disabled={isDisabled} className="form-control" type="text" placeholder={geoTownName || '-'} />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col sm={4} md={4}>
                                                        <FormGroup>
                                                            <Label>{'Branch Name'}</Label>
                                                            <input disabled={isDisabled} className="form-control" type="text" placeholder={branchName || '-'} />
                                                        </FormGroup>
                                                    </Col>

                                                    {/* <Col md={12}>
                                                    <FormGroup>
                                                        <Label>{EmailAddress}</Label>
                                                        <input disabled={isDisabled} className="form-control" type="email" placeholder={email||'email'} {...register('emailAddress', { required: true })} /><span style={{ color: 'red' }}>{errors.emailAddress && 'EmailAddress is required'} </span>
                                                    </FormGroup>
                                                </Col> */}
                                                    <Col md={6}>
                                                        <FormGroup>
                                                            <Label>{'Remark'}</Label>
                                                            <input disabled={isDisabled} className="form-control" type="text" placeholder={remark || '-'} />
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md={6}>
                                                        <FormGroup>
                                                            <Label>{Address}</Label>
                                                            <input disabled={isDisabled} className="form-control" type="text" placeholder={address || '-'} />
                                                        </FormGroup>
                                                    </Col>
                                                    {/* <Col md={12}>
                                                    <FormGroup>
                                                        <Label>{Address}</Label>
                                                        <input disabled={isDisabled} className="form-control" type="text" placeholder={address||'-'}  />
                                                    </FormGroup>
                                                </Col> */}

                                                </Row>
                                            </CardBody>
                                        </Form>
                                    </Card>
                                </Col>}
                                {/* {employeeId != null &&
                                    <Col xl={12}>
                                        <Card>
                                            <Form>
                                                <CardBody>
                                                    <Row>
                                                        <p style={{ fontSize: 18, }}>{'HR Dates:'}</p>
                                                        <Col sm={4} md={4}>
                                                            <FormGroup>
                                                                <Label>{'Join Date'}</Label>
                                                                <input disabled={isDisabled} className="form-control" type="text" placeholder={joinDate || '-'} />
                                                            </FormGroup>
                                                        </Col>
                                                        <Col sm={4} md={4}>
                                                            <FormGroup>
                                                                <Label>{'Birth Date'}</Label>
                                                                <input disabled={isDisabled} className="form-control" type="text" placeholder={birthDate || '-'} />
                                                            </FormGroup>
                                                        </Col>
                                                        <Col sm={4} md={4}>
                                                            <FormGroup>
                                                                <Label>{'Probation Date'}</Label>
                                                                <input disabled={isDisabled} className="form-control" type="text" placeholder={probationDate || '-'} />
                                                            </FormGroup>
                                                        </Col>
                                                        <Col sm={4} md={4}>
                                                            <FormGroup>
                                                                <Label>{'Training Start Date'}</Label>
                                                                <input disabled={isDisabled} className="form-control" type="text" placeholder={trainingStartDate || '-'} />
                                                            </FormGroup>
                                                        </Col>
                                                        <Col sm={4} md={4}>
                                                            <FormGroup>
                                                                <Label>{'Training End Date'}</Label>
                                                                <input disabled={isDisabled} className="form-control" type="text" placeholder={trainingEndDate || '-'} />
                                                            </FormGroup>
                                                        </Col>
                                                        <Col sm={4} md={4}>
                                                            <FormGroup>
                                                                <Label>{'Confirmation Date'}</Label>
                                                                <input disabled={isDisabled} className="form-control" type="text" placeholder={confirmationDate || '-'} />
                                                            </FormGroup>
                                                        </Col>
                                                        <Col sm={4} md={4}>
                                                            <FormGroup>
                                                                <Label>{'Transfer Date'}</Label>
                                                                <input disabled={isDisabled} className="form-control" type="text" placeholder={transferDate || '-'} />
                                                            </FormGroup>
                                                        </Col>
                                                        <Col sm={4} md={4}>
                                                            <FormGroup>
                                                                <Label>{'Resign Date'}</Label>
                                                                <input disabled={isDisabled} className="form-control" type="text" placeholder={resignDate || '-'} />
                                                            </FormGroup>
                                                        </Col>
                                                        <Col sm={4} md={4}>
                                                            <FormGroup>
                                                                <Label>{'Reliving Date'}</Label>
                                                                <input disabled={isDisabled} className="form-control" type="text" placeholder={relivingDate || '-'} />
                                                            </FormGroup>
                                                        </Col>
                                                        <Col sm={4} md={4}>
                                                            <FormGroup>
                                                                <Label>{'NSM Approve Date'}</Label>
                                                                <input disabled={isDisabled} className="form-control" type="text" placeholder={nsmApproveDate || '-'} />
                                                            </FormGroup>
                                                        </Col>
                                                        <Col sm={4} md={4}>
                                                            <FormGroup>
                                                                <Label>{'Resignation Rejected Date'}</Label>
                                                                <input disabled={isDisabled} className="form-control" type="text" placeholder={resignationRejectedDate || '-'} />
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                </CardBody>
                                            </Form>
                                        </Card>
                                    </Col>} */}
                                {/* {employeeId != null &&
                                    <Col xl={12}>
                                        <Card>
                                            <Form>
                                                <CardBody>
                                                    <Row>
                                                        <p style={{ fontSize: 18, }}>{'HR Account:'}</p>
                                                        <Col sm={4} md={4}>
                                                            <FormGroup>
                                                                <Label>{'Personal Bank'}</Label>
                                                                <input disabled={isDisabled} className="form-control" type="text" placeholder={personalBank || '-'} />
                                                            </FormGroup>
                                                        </Col>
                                                        <Col sm={4} md={4}>
                                                            <FormGroup>
                                                                <Label>{'Personal Account Number'}</Label>
                                                                <input disabled={isDisabled} className="form-control" type="text" placeholder={personalAccountNumber || '-'} />
                                                            </FormGroup>
                                                        </Col>
                                                        <Col sm={4} md={4}>
                                                            <FormGroup>
                                                                <Label>{'Pf Esic Contribution'}</Label>
                                                                <input disabled={isDisabled} className="form-control" type="text" placeholder={pfEsicContribution || '-'} />
                                                            </FormGroup>
                                                        </Col>
                                                        <Col sm={4} md={4}>
                                                            <FormGroup>
                                                                <Label>{'Pf Number'}</Label>
                                                                <input disabled={isDisabled} className="form-control" type="text" placeholder={pfNumber || '-'} />
                                                            </FormGroup>
                                                        </Col>
                                                        <Col sm={4} md={4}>
                                                            <FormGroup>
                                                                <Label>{'Esci Number'}</Label>
                                                                <input disabled={isDisabled} className="form-control" type="text" placeholder={esciNumber || '-'} />
                                                            </FormGroup>
                                                        </Col>
                                                        <Col sm={4} md={4}>
                                                            <FormGroup>
                                                                <Label>{'Gross Salary'}</Label>
                                                                <input disabled={isDisabled} className="form-control" type="text" placeholder={grossSalary || '-'} />
                                                            </FormGroup>
                                                        </Col>
                                                        <Col sm={4} md={4}>
                                                            <FormGroup>
                                                                <Label>{'Payment Mode'}</Label>
                                                                <input disabled={isDisabled} className="form-control" type="text" placeholder={paymentMode || '-'} />
                                                            </FormGroup>
                                                        </Col>
                                                        <Col sm={4} md={4}>
                                                            <FormGroup>
                                                                <Label>{'Salary Bank'}</Label>
                                                                <input disabled={isDisabled} className="form-control" type="text" placeholder={salaryBank || '-'} />
                                                            </FormGroup>
                                                        </Col>
                                                        <Col sm={4} md={4}>
                                                            <FormGroup>
                                                                <Label>{'Salary Account Number'}</Label>
                                                                <input disabled={isDisabled} className="form-control" type="text" placeholder={salaryAccountNumber || '-'} />
                                                            </FormGroup>
                                                        </Col>
                                                        <Col sm={4} md={4}>
                                                            <FormGroup>
                                                                <Label>{'Tds Status'}</Label>
                                                                <input disabled={isDisabled} className="form-control" type="text" placeholder={tdsStatus || '-'} />
                                                            </FormGroup>
                                                        </Col>
                                                        <Col sm={4} md={4}>
                                                        <FormGroup>
                                                            <Label>{'Resignation Rejected Date'}</Label>
                                                            <input disabled={isDisabled} className="form-control" type="text" placeholder={resignationRejectedDate || '-'} />
                                                        </FormGroup>
                                                    </Col>
                                                    </Row>
                                                </CardBody>
                                            </Form>
                                        </Card>
                                    </Col>} */}
                            </Row>
                        </div>

                        <CommonModal
                            isOpen={modalOpen4}
                            toggle={() => setModalOpen4(false)}
                            title="Update Employee Details"
                            size="xl"
                        >
                            <div className="p-3">
                                <div className="row">
                                    {/* ================= Section: Basic Info ================= */}
                                    <div className="col-12">
                                        <h5 className="mb-3 border-bottom pb-1">👤 Basic Information</h5>
                                    </div>

                                    {[
                                        { label: 'First Name', value: firstName, setter: setFirstName },
                                        { label: 'Last Name', value: lastName, setter: setLastName },
                                        { label: 'Email', value: email, setter: setemail },
                                        { label: 'Phone', value: phone, setter: setPhone },
                                        // { label: 'Username', value: username, setter: setUsername },
                                        // { label: 'ISD Code', value: isdCode, setter: setIsdCode },
                                        { label: 'Remark', value: remark, setter: setRemark },
                                    ].map((f, idx) => (
                                        <div className="col-md-6 mb-3" key={`basic-${idx}`}>
                                            <div className="d-flex align-items-center">
                                                <label className="me-2" style={{ width: '40%' }}>
                                                    {f.label}
                                                </label>
                                                <Input
                                                    className="form-control"
                                                    value={f.value || ''}
                                                    onChange={(e) => f.setter(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    ))}

                                    {/* ================= Section: Address ================= */}
                                    <div className="col-12 mt-3">
                                        <h5 className="mb-3 border-bottom pb-1">🏠 Address Information</h5>
                                    </div>

                                    {[
                                        { label: 'Residential Address', value: resiAddress, setter: setResiAddress },
                                        { label: 'Address', value: address, setter: setAddress },
                                        { label: 'Cost Number', value: costnumber, setter: setCostnumber },
                                        { label: 'Spoken Language', value: employeeSpokenLanguage, setter: setEmployeeSpokenLanguage },
                                    ].map((f, idx) => (
                                        <div className="col-md-6 mb-3" key={`addr-${idx}`}>
                                            <div className="d-flex align-items-center">
                                                <label className="me-2" style={{ width: '40%' }}>
                                                    {f.label}
                                                </label>
                                                <Input
                                                    className="form-control"
                                                    value={f.value || ''}
                                                    onChange={(e) => f.setter(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    ))}

                                    {/* ================= Section: HR Dates ================= */}
                                    <div className="col-12 mt-3">
                                        <h5 className="mb-3 border-bottom pb-1">📅 HR Dates</h5>
                                    </div>

                                    {[
                                        { label: 'Birth Date', value: birthDate, setter: setBirthDate },
                                        { label: 'Join Date', value: joinDate, setter: setJoinDate },
                                        { label: 'Probation Date', value: probationDate, setter: setProbationDate },
                                        { label: 'Confirmation Date', value: confirmationDate, setter: setConfirmationDate },
                                        { label: 'Training Start Date', value: trainingStartDate, setter: setTrainingStartDate },
                                        { label: 'Training End Date', value: trainingEndDate, setter: setTrainingEndDate },
                                        { label: 'Transfer Date', value: transferDate, setter: setTransferDate },
                                        { label: 'Relieving Date', value: relivingDate, setter: setRelivingDate },
                                        { label: 'NSM Approve Date', value: nsmApproveDate, setter: setNsmApproveDate },
                                        { label: 'Resignation Rejected Date', value: resignationRejectedDate, setter: setResignationRejectedDate },
                                    ].map((f, idx) => (
                                        <div className="col-md-6 mb-3" key={`date-${idx}`}>
                                            <div className="d-flex align-items-center">
                                                <label className="me-2" style={{ width: '50%' }}>
                                                    {f.label}
                                                </label>
                                                <Input
                                                    className="form-control"
                                                    placeholder="YYYY-MM-DD"
                                                    value={f.value || ''}
                                                    onChange={(e) => f.setter(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    ))}

                                    {/* ================= Section: Bank & Salary ================= */}
                                    <div className="col-12 mt-3">
                                        <h5 className="mb-3 border-bottom pb-1 ">💼 Bank & Salary Details</h5>
                                    </div>

                                    {[
                                        { label: 'Personal Bank', value: personalBank, setter: setPersonalBank },
                                        { label: 'Personal Account Number', value: personalAccountNumber, setter: setPersonalAccountNumber },
                                        { label: 'PF/ESIC Contribution', value: pfEsicContribution, setter: setPfEsicContribution },
                                        { label: 'PF Number', value: pfNumber, setter: setPfNumber },
                                        { label: 'ESCI Number', value: esciNumber, setter: setEsciNumber },
                                        { label: 'Gross Salary', value: grossSalary, setter: setGrossSalary },
                                        { label: 'Payment Mode', value: paymentMode, setter: setPaymentMode },
                                        { label: 'Salary Bank', value: salaryBank, setter: setSalaryBank },
                                        { label: 'Salary Account Number', value: salaryAccountNumber, setter: setSalaryAccountNumber },
                                        { label: 'TDS Status', value: tdsStatus, setter: setTdsStatus },
                                    ].map((f, idx) => (
                                        <div className="col-md-6 mb-3" key={`bank-${idx}`}>
                                            <div className="d-flex align-items-center">
                                                <label className="me-2" style={{ width: '50%' }}>
                                                    {f.label}
                                                </label>
                                                <Input
                                                    className="form-control"
                                                    value={f.value || ''}
                                                    onChange={(e) => f.setter(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                <div className="d-flex justify-content-end gap-2 mt-4">
                                    <button
                                        className="btn btn-primary"
                                        onClick={handleUpdateEmployeeDetails}
                                        disabled={loading}
                                    >
                                        {loading ? 'Updating…' : 'Update'}
                                    </button>
                                    <button
                                        className="btn btn-secondary"
                                        onClick={() => setModalOpen4(false)}
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </CommonModal>


                    </Container>
                    {/* </Card> */}
                    {employeeId != null && <BorderTabs employeeIdProp={employeeId} />}
                </div >)
            }
        </div >
    )
}
